import * as mobx from 'mobx';
import BlogApi from "../api/blog-api";
import CategoryApi from "../api/category-api";
import CountryApi from "../api/country-api";
import EmailApi from "../api/email-api";
import OrderApi from "../api/order-api";
import ParameterApi from "../api/parameter-api";
import ProductApi from "../api/product-api";
import ShippingApi from "../api/shipping-api";
import SysApi from "../api/sys-api";
import {SysInfo} from "../models/sys/sys-info";
import BlogStore from "./blog-store";
import CartStore from "./cart-store";
import CountryStore from "./country-store";
import EmailStore from "./email-store";
import OrderStore from "./order-store";
import ProductStore from "./product-store";
import ShippingStore from "./shipping-store";
import SysStore from "./sys-store";
import ToasterStore from "./toaster-store";
import TranslationStore from "./translation-store";

interface IRootStore {
    blogStore: BlogStore;
    cartStore: CartStore;
    countryStore: CountryStore;
    emailStore: EmailStore;
    orderStore: OrderStore;
    productStore: ProductStore;
    shippingStore: ShippingStore;
    sysStore: SysStore;
    toasterStore: ToasterStore;
    translationStore: TranslationStore;
}

export default class RootStore implements IRootStore {
    public sysInfo: SysInfo;
    public blogStore: BlogStore;
    public cartStore: CartStore;
    public countryStore: CountryStore;
    public emailStore: EmailStore;
    public orderStore: OrderStore;
    public productStore: ProductStore;
    public shippingStore: ShippingStore;
    public sysStore: SysStore;
    public toasterStore: ToasterStore;
    public translationStore: TranslationStore;
    public blogApi: BlogApi;
    public categoryApi: CategoryApi;
    public countryApi: CountryApi;
    public emailApi: EmailApi;
    public orderApi: OrderApi;
    public productApi: ProductApi;
    public shippingApi: ShippingApi;
    public parameterApi: ParameterApi;
    public sysApi: SysApi;

    constructor() {
        mobx.configure({enforceActions: "observed"});
        this.sysInfo = new SysInfo();
        this.blogStore = new BlogStore(this);
        this.cartStore = new CartStore(this);
        this.countryStore = new CountryStore(this);
        this.emailStore = new EmailStore(this);
        this.orderStore = new OrderStore(this);
        this.productStore = new ProductStore(this);
        this.shippingStore = new ShippingStore(this);
        this.sysStore = new SysStore(this);
        this.toasterStore = new ToasterStore(this);
        this.translationStore = new TranslationStore(this);
        this.blogApi = new BlogApi();
        this.categoryApi = new CategoryApi();
        this.countryApi = new CountryApi();
        this.emailApi = new EmailApi();
        this.orderApi = new OrderApi();
        this.productApi = new ProductApi();
        this.shippingApi = new ShippingApi();
        this.parameterApi = new ParameterApi();
        this.sysApi = new SysApi();
    }
}



// WEBPACK FOOTER //
// ./src/stores/root-store.ts